// /src/services/UserService.js
import axios from 'axios'
import { mkArgStr, requestHandler, responseHandler } from '@/services/API'

// passing URL this so we don't have to change it for requests to work in production
// var currentURLObj = new URL(window.location)

const userAuthClient = axios.create({
  baseURL: `/wp-json/jwt-auth/v1/`,
  timeout: 60000,
})

userAuthClient.interceptors.request.use(request => requestHandler(request))
// userAuthClient.interceptors.response.use(response => responseHandler(response))

export default {
  async validateJWT(token) {
    const validToken = await userAuthClient.post('token/validate', { token })
    return validToken
  },

  async requestToken(creds) {
    try {
      const user = await userAuthClient.post('token', mkArgStr(creds), {
        withCredentials: true,
      })
      return user
    } catch (err) {
      return err
    }
  },
}
